(() => {
  const bindStickyBar = (root = document) => {
    const bar = root.querySelector?.('.sticky-add-to-cart__bar') || document.querySelector('.sticky-add-to-cart__bar');
    const buyButtons = document.querySelector('.buy-buttons-block');

    if (!bar || !buyButtons || bar.dataset.v4FallbackBound === 'true') return;

    bar.dataset.v4FallbackBound = 'true';
    let frameRequested = false;

    const update = () => {
      frameRequested = false;
      const buyRect = buyButtons.getBoundingClientRect();
      const footer = document.querySelector('footer, [class*="footer-group"]');
      const footerIsNear = footer ? footer.getBoundingClientRect().top < window.innerHeight + 200 : false;
      const shouldStick = buyRect.bottom < 0 && !footerIsNear;

      bar.dataset.stuck = shouldStick ? 'true' : 'false';
    };

    const requestUpdate = () => {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    update();
  };

  const init = () => bindStickyBar(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => bindStickyBar(event.target));
})();
